import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  postPetFormImagesStart,
  postPetFormImagesSuccess,
  postPetFormImagesDataSuccess,
  postPetFormImagesFailure,
} from "../reducers/postPetFormImagesReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const postPetFormImages = createAsyncThunk(
  "postPetFormImages",
  async ({ id,formData }, thunkAPI) => {
    try {
      thunkAPI.dispatch(postPetFormImagesStart());
      const token = Cookies.get("token");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/PetInsurance/PostUploadImage?pet_Detail_Id=${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(postPetFormImagesSuccess(responseData?.data?.result));
      thunkAPI.dispatch(postPetFormImagesDataSuccess(formData));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(postPetFormImagesFailure(error.response.data.Message));

      if (error.response.data.Message) {
        thunkAPI.dispatch(postPetFormImagesFailure(error.response.data.Message));
      } else {
        thunkAPI.dispatch(postPetFormImagesFailure(error.response.data.status));
      }
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
